import { React, Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PolicyLookupSpinner } from "../../../PolicyLookupSpinner";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import "./ContractSelectionList.scss";
import { ConfirmNoCoverageModal } from "../ConfirmNoCoverageModal";
import { ConfirmMileageExceededModal } from "../ConfirmMileageExceededModal";
import { devLog } from "utils/devLog";

const policyMap = new Map();

export default function ContractSelectionList(props) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.VIN);

  const [searchValueLN, setSearchValueLN] = useState(props.currState.MemberLookup.LastName);

  const [odometer, setOdometer] = useState(props.currState.MemberLookup.Odometer);

  const [contractData, setContractData] = useState(undefined);
  const [selectedVehicle, setSelectedVehicle] = useState(undefined);

  const [showConfirmCoverage, setShowConfirmCoverage] = useState(false);
  const [showMileageExceeded, setShowMileageExceeded] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    //devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setContractData(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: props.currState.FirstName,
        phone: props.currState.Number,
        lastName: searchValueLN,
        vin: searchValue,
        odometer: odometer,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (typeof json.data.contract === "object") {
          setContractData(json.data.contract);
          if (json.data.error) {
            setError(json.data.error.message);
            onLoad(false);
          } else {
            //check to see if the vehicles array is empty.
            //if the vehicle array is empty onLoad(false);
            //if the vehicle array is not empty onLoad(true);
            if (json.data.contract.vehicles.length) {
              policyMap.set(searchValue, json.data.contract);
              onLoad(true);
            } else {
              onLoad(false);
              setContractData(undefined);
              setError("Unable to locate contract");
              onLoad(false);
            }
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError("Unable to process contract lookup!");
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })
      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setError("Unable to process contract lookup!");
        onLoad(false);
      });
  };

  const onSelect = (vehicle) => {
    //devLog("onSelect", vehicle, odometer);
    setSelectedVehicle(vehicle);

    if (vehicle && vehicle.coverage.length) {
      setShowConfirmCoverage(false);

      if (parseInt(vehicle.expMiles) < odometer) {
        setShowMileageExceeded(true);
      } else {
        setShowMileageExceeded(false);
        if (typeof props.onSelect === "function") {
          props.onSelect(contractData, vehicle);
        }
      }
    } else {
      setShowConfirmCoverage(true);
    }
  };

  const onUserBack = (e) => {
    e.preventDefault();
    setShowConfirmCoverage(false);
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onConfirmCoverage = (e) => {
    setShowConfirmCoverage(false);
    if (typeof props.onSelect === "function") {
      props.onSelect(contractData, selectedVehicle);
    }
  };

  const onConfirmCoverageCancel = () => {
    setShowConfirmCoverage(false);
    setSelectedVehicle(undefined);
    if (typeof props.onSelect === "function") {
      props.onSelect(contractData, undefined);
    }
  };

  const onConfirmMileageCancel = () => {
    setShowMileageExceeded(false);
    setSelectedVehicle(undefined);
    if (typeof props.onSelect === "function") {
      props.onSelect(contractData, undefined);
    }
  };

  return (
    <>
      <div className="formContainer">
        {contractData ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerFirstName")}:</b> {contractData.firstName}
              </div>
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerLastName")}:</b> {contractData.lastName}
              </div>
            </div>
            <div className="vehicleHeader">
              <h4 className="slim">{t("description.ContractInformationHeader3")}</h4>
            </div>
            <div className="vehicle-list-container">
              <>
                {contractData.vehicles.map((item, index) => {
                  return (
                    <div
                      key={index}
                      value={item}
                      className={`vehicle-list-item ${selectedVehicle === item ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(item);
                      }}
                    >
                      <div value={item} className="vehicle-list-item-col-1">
                        <h5 value={item}>
                          {item.make} {item.model} {item.year}
                        </h5>
                        {/* <p>{item.vin}</p> */}
                        <p></p>
                        <div className="coverage-list">
                          {item.coverage.length ? (
                            item.coverage.map((coverage, cIdx) => {
                              return <div key={`coverage-${cIdx}`}>{coverage.description}</div>;
                            })
                          ) : (
                            <></>
                          )}{" "}
                          {/*<div className="uncovered">No Coverage</div>*/}
                        </div>
                      </div>
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedVehicle === item ? "selected" : ""}
                      />
                    </div>
                  );
                })}
                <div className="vehicleHeader">
                  <h4>{t("description.PolicyInformationHeader4")}</h4>
                  <span>{t("description.PolicyInformationHeader5")}</span>
                </div>
                <div
                  className={`vehicle-list-item ${selectedVehicle === null ? "selected" : ""}`}
                  onClick={(e) => {
                    onSelect(null);
                  }}
                >
                  <div className="vehicle-list-item-col-1">
                    <h5>Unlisted Vehicle</h5>
                    <div className="coverage-list">
                      {<></>} {/*<div className="uncovered">No Coverage</div>*/}
                    </div>
                  </div>
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedVehicle === null ? "selected" : ""}
                  />
                </div>
              </>
            </div>
            <ConfirmNoCoverageModal
              isOpen={showConfirmCoverage}
              logo={props.currState.localGroupLogo}
              onYes={onConfirmCoverage}
              onNo={onConfirmCoverageCancel}
            />
            <ConfirmMileageExceededModal
              isOpen={showMileageExceeded}
              logo={props.currState.localGroupLogo}
              onYes={onConfirmCoverage}
              onNo={onConfirmMileageCancel}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitle`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
